import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "reactive-width backdrop" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "top-wrapper" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.popular.placeId != -1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "button-indigo",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pickPopular()))
            }, _toDisplayString(_ctx.popular.Name), 1),
            _createTextVNode(" is popular in your area: " + _toDisplayString(_ctx.zip) + " ", 1),
            _hoisted_4
          ]),
          _createTextVNode(" Or go on to the "),
          _createElementVNode("button", {
            class: "button-indigo",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toTournament()))
          }, " Tournament-> ")
        ]))
      : _createCommentVNode("", true)
  ]))
}